import IntegrationsPageContent from "@/components/integrations/IntegrationsPageContent";

const IntegrationsSettingsContent = () => {
  return <IntegrationsPageContent />;
};

export default IntegrationsSettingsContent;
